import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import {
  postSearchUmumConfig
} from '../../services/search';
import SearchSection from '../../components/fragments/SearchSection';
import { showNotification } from '../../utilities/mantineNotification';
import { Button, Container, Divider, Flex, Grid, Text } from '@mantine/core';
import LoaderContentItem from '../../components/section/ContentSection/LoaderContentItem';
import PublicLayout from '../../components/layout/PublicLayout';
import ModalWrapper from '../../components/elements/ModalWrapper';
import LayoutLogo from '../../components/layout/main/LayoutLogo';
import LoginForm from '../login/LoginForm';
import microsoftLogo from '../../assets/img/microsoft-logo.png';
import { directTypes, redirectToAzureAD } from '../../utilities';
import { useMsal } from '@azure/msal-react';

const SearchUmumPage = () => {
  const location = useLocation();

  const queryParams: any = new URLSearchParams(location.search);

  const querysearch = queryParams.get('search');

  const getUserData: any = () => {
    const jsonString = localStorage.getItem('persist:root');
    const object = JSON.parse(jsonString);
    return JSON.parse(object.auth).userData;
  };

  const _userData = getUserData();

  const [dataPayload, setDataPayload] = useState({
    BusinessUnitCode: _userData?.businessUnitCode || '',
    type: '',
    isUmum: 'Y',
    limit: 8,
    course: {
      search: querysearch?.toLowerCase()
    },
    content: {
      search: querysearch?.toLowerCase(),
      category: null
    },
    personalwisdom: {
      search: querysearch?.toLowerCase()
    },
    leaderwisdom: {
      search: querysearch?.toLowerCase()
    },
    fns: {
      search: querysearch?.toLowerCase()
    },
    testimony: {
      search: querysearch?.toLowerCase()
    }
  });

  useEffect(() => {
    const dataTemp = {
      BusinessUnitCode: _userData?.businessUnitCode || '',
      type: '',
      isUmum: 'Y',
      limit: 8,
      course: {
        search: querysearch?.toLowerCase()
      },
      content: {
        search: querysearch?.toLowerCase(),
        category: null
      },
      personalwisdom: {
        search: querysearch?.toLowerCase()
      },
      leaderwisdom: {
        search: querysearch?.toLowerCase()
      },
      fns: {
        search: querysearch?.toLowerCase()
      },
      testimony: {
        search: querysearch?.toLowerCase()
      }
    };
    setDataPayload(dataTemp);
  }, [querysearch]);

  useEffect(() => {
    fetchedSearchConfig.mutate(dataPayload);
  }, [dataPayload]);

  const fetchedSearchConfig = useMutation({
    mutationFn: postSearchUmumConfig,
    onSuccess: () => {
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const { instance } = useMsal();
  const [modalLogin, setModalLogin] = useState(false);
  const [loading, setLoading] = useState(false);

  const onLogClick = () => {
    setModalLogin(!modalLogin);
  };

  const doLogin = () => {
    setLoading(true);
    setModalLogin(false);
    redirectToAzureAD(directTypes.LOGIN, instance, () => {
      setLoading(false);
    });
  };

  return (
    <PublicLayout titlePage="General Search" size="lg">
      <ModalWrapper isVisible={modalLogin} onClose={() => setModalLogin(false)}>
        <LayoutLogo />

        <Flex direction={'column'} mt={32}>
          <Text c={'dark'} fz={14} fw={600} mb={8}>
            Login with Employee/Teacher/Lecturer account
          </Text>

          <Button onClick={doLogin} loading={loading} variant="outline">
            <img src={microsoftLogo} className="mr-2" /> Sign in with Microsoft
          </Button>
        </Flex>

        <Divider
          my={32}
          labelPosition="center"
          label={<Text fz={12}>Or</Text>}
        />

        <LoginForm />
      </ModalWrapper>
      <Container size={'lg'}>
        {fetchedSearchConfig.isLoading && (
          <>
            <Grid mb={10}>
              {[...Array(4)].map((_, index) => (
                <Grid.Col key={index} span={3}>
                  <LoaderContentItem />
                </Grid.Col>
              ))}
            </Grid>
            <Grid mb={10}>
              {[...Array(4)].map((_, index) => (
                <Grid.Col key={index} span={3}>
                  <LoaderContentItem />
                </Grid.Col>
              ))}
            </Grid>
            <Grid mb={10}>
              {[...Array(4)].map((_, index) => (
                <Grid.Col key={index} span={3}>
                  <LoaderContentItem />
                </Grid.Col>
              ))}
            </Grid>
          </>
        )}
        <SearchSection
          onLoginClick={onLogClick}
          isUmum={true}
          querysearch={querysearch}
          pageSection={fetchedSearchConfig?.data?.data?.pageSection || []}
          loading={fetchedSearchConfig.isLoading}
          isError={fetchedSearchConfig.isError}
        />
      </Container>
    </PublicLayout>
  );
};

export default SearchUmumPage;
